import React from 'react'

export default function AcademicCouncil() {
    return (
        <div>AcademicCouncil</div>
    )
}
